import { Injectable } from '@angular/core';
import { StringHelpers } from '@mode/shared/util-js';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ReportPinModel extends ModeModelBase {
  override _name = 'reportPin';
  override idAttribute = 'token';
  pinned_type: any;
  override belongsTo = 'report';
  override parentIdAttribute = 'token';

  override attributes = [{ name: 'pinned_id' }, { name: 'pinned_type' }, { name: 'schemadonna_id' }];
  override hasPoly = [{ name: 'pinned', id: 'pinned_id', type: 'pinned_type' }];
  override initialize(resource: any): void {
    this.initEmbedded('pinned', StringHelpers.camalize(this.pinned_type), false);
  }
}

@Injectable({ providedIn: 'root' })
export class ReportPinModelAccessor extends ModelAccessorBase<ReportPinModel> {
  createModel(resource, opts?) {
    const model = new ReportPinModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  override name = 'reportPin';
  override idAttribute = 'token';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = ['report'];
  pinnedTypeRank(pin) {
    switch (pin.pinned_type) {
      case 'DataSourceTable':
        return 0;
      case 'Table':
        return 1;
      case 'Report':
        return 2;
      default:
        return 3;
    }
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.reportPin');
  }
}
